import { styled, Paper } from "@mui/material";

export const PaperStyled = styled(Paper)(
  ({ theme }) => `
  padding: ${theme.spacing(4, 5)};
  width: 360px;
`
);
